export const isBlackBarTitle = false
